<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :queryOnLoad="queryOnLoad" :confKey="confKey" :configAuto="true" :queryHandler="queryHandler" :onConfigReady="onConfigReady"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, getComnMerchantBizTag, getComnMerchantAttTag } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { showGrpDownloadDlg } from '../ctrl/dialog'
    import { openApplyDescDlg } from '../stock/selectDlg';
    import { checkUserActionPerm } from '../index'
    import { openWorkVoucherDetailDlg, openWorkVoucherRecsDlg, openDeviceRepairRecDlg, openServcWorkStaffQualiDlg } from './showDetailDlg'
    import { openStaffQualiForSelectDlg } from '../quali/selectDlg';
    import { openServicerComForSelectDlg, openServicerComTreeSelectDlg } from '../orgStruct/selectDlg';

    import servcDelivApi from '../../api/servcDeliv'
    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user';

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    //
    let bizTagObj = null;
    let attTagObj = null;
    //
    export default {
        name: 'swb-servc-work-voucher-dlgt-list',
        desc: '工单列表',
        props: {
            masterId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                confKey: "servc-work-voucher-dlgt-list",
                tableHeight: 700,
                queryOnLoad: true,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: true, //行号列是否固定（默认：false）
                btnColName: '',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '',//操作列标题（默认：'操作'）
                btnColWidth: '',//操作列宽度（默认：100）
                btnColFixed: false, //操作列是否固定
                resultColConf: {},
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                no: null,
                deviceSubNoId: null,
                //
                emgLevelMap: {},
                workServcTypeMap: {},
                //
                bizAspect: getEnumInfoWith('retailerBizAspect', 'name', 'WorkVoucher').value,
                batchFlag: false,
                tagIds: [],
                optionRows: [],
                servcWorkSrcFlagMap: getEnumMap("servcWorkSrcFlag", "value2text"),
                performFlagEnumMap: getEnumMap('performFlag', 'value2text')
        }
        },
        created: function () {
            bizTagObj = getComnMerchantBizTag();
            attTagObj = getComnMerchantAttTag();
            this.pageSize = this.pageSizes.first();
            this.emgLevelMap = getEnumMap('emgLevel', 'value2text');
            this.workServcTypeMap = getEnumMap('workServcType', 'value2text');
        },
        mounted() {
            let self = this;
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '<span>' + row.no + '</span>';
                        if(row.requestProxied) {
                            domHtml = domHtml + '<i class="swb-icon table-agent-left"></i>';
                        }
                        if(row.qualiClaimFlag) {
                            domHtml = domHtml + '<i name="quali_claim" class="swb-icon table-qualific"></i>';
                        }
                        return domHtml;
                    },
                    'tradeNo': function (row, colName, colValue, rowIndex, colConf) {
                        return row.tradeNo != null ? '<span>' + row.tradeNo + '</span>' : '<span></span>';
                    },
                    'emgLevelName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.emgLevel == 0) {
                            return '<span class="swb-tags swb-tags-success">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        } else if(row.emgLevel == 1) {
                            return '<span class="swb-tags swb-tags-warning">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        } else {
                            return '<span class="swb-tags swb-tags-danger">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        }
                    },
                    'grabName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.grabFlag) {
                            return '<span>' + "抢单" + '</span>';
                        } else {
                            return '<span>' + "定向指派" + '</span>';
                        }
                    },
                    "servcTypeName": function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if(row.servcType != null) {
                            domHtml = domHtml + '<span class="swb-tags swb-tags-success">' + self.workServcTypeMap[row.servcType] + '</span>';
                        }
                        if(row.remoted) {
                            domHtml = domHtml + '<span class="swb-tags swb-tags-success">' + "远程解决" + '</span>'
                        }
                        return domHtml;
                    },
                    'stateDesc': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.closed) {
                            return '<span class="font-red">' + "已关闭" + '</span>'
                        } else if(row.invalid) {
                            return '<span class="font-red">' + "已作废" + '</span>'
                        } else if(row.stateText == '服务暂停') {
                            return '<span class="font-red">' + '服务暂停(原因:' + row.stateDesc + ')</span>'
                        } else {
                            return row.stateText;
                        }
                    },
                    'orderNo': function (row, colName, colValue, rowIndex, colConf) {
                        return row.orderNo != null ? row.orderNo : null
                    },
                    'amount': function (row, colName, colValue, rowIndex, colConf) {
                        return row.amount != null ? (row.amount).toFixed(2) : 0.00;
                    },
                    'servcFileBrowseUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.servcFileBrowseUrl)) {
                            return '<a><img style="height: 36px;width: 36px" src="' + row.servcFileBrowseUrl + '"/></a>';
                        } else {
                            return "";
                        }
                    },
                    'staffQuali': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.engineerId != null) {
                            return '<a href="#" style="color:purple;">' + "个人资质" + '</a>'
                        } else {
                            return '';
                        }
                    },
                    'srcMerchantName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.srcMerchantType == 2) {
                            return row.srcMerchantName
                        }
                    },
                    'beyondWrntName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.beyondWrnt) {
                            return '<span class="swb-tags swb-tags-danger">' + "约定外" + '</span>'
                        } else {
                            return '<span class="swb-tags swb-tags-success">' + "约定内" + '</span>'
                        }
                    },
                    'evalFlag': function (row, colName, colValue, rowIndex, colConf) {
                        return row.evalFlag ? '是' : '';
                    },
                    'manualShopName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servicerShopId == null) {
                            return '未指派';
                        } else {
                            return row.manualShopFlag ? '手工' : '自动';
                        }
                    },
                    'manualEngName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.engineerId == null) {
                            return '未指派';
                        } else {
                            return row.manualEngFlag ? '手工' : '自动';
                        }
                    },
                    'performName': function (row, colName, colValue, rowIndex, colConf) {
                        return self.performFlagEnumMap[row.performFlag]
                    },
                    'servicerTag': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.servicerTag)) {
                            let servicerTag = row.servicerTag;
                            let tagIdList = [];
                            if(!Utils.isNoB(servicerTag)) {
                                if(servicerTag.indexOf("|") >= 0) {
                                    servicerTag = servicerTag.substring(1, servicerTag.length - 1);
                                    tagIdList = servicerTag.split("|") || [];
                                } else {
                                    return '<span class="swb-tags swb-tags-success mr5">' + servicerTag + '</span>';
                                }
                            }
                            let html = '';
                            for(let i = 0; i < tagIdList.length; i++) {
                                let tagId = parseInt(tagIdList[i]);
                                let tagName = bizTagObj.getBizTagNameById(tagId);
                                if(tagName != null) {
                                    html += '<span class="swb-tags swb-tags-success mr5">' + tagName + '</span>';
                                }
                            }
                            return html;
                        }
                    },
                    'jbAmount': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.performFlag == 2 && row.finished) {
                            return '<span>' + row.jbAmount + '</span>'
                        }
                    },
                    'repaireTimeMi': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.repaireTimeMi != null) {
                            return '<span>' + (row.repaireTimeMi / 60).toFixed(2) + '</span>';
                        } else {
                            return '<span>' + 0.00 + '</span>'
                        }
                    },
                    'servRepaireTimeMi': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.servRepaireTimeMi != null) {
                            return '<span>' + (row.servRepaireTimeMi / 60).toFixed(2) + '</span>';
                        } else {
                            return '<span>' + 0.00 + '</span>'
                        }
                    },
                    'repaireTimeH': function (row, colName, colValue, rowIndex, colConf) {
                        return row.repaireTimeH.toFixed(2)
                    },
                    'servRepaireTimeMiH': function (row, colName, colValue, rowIndex, colConf) {
                        return row.servRepaireTimeMiH.toFixed(2)
                    },
                    'reputably': function (row, colName, colValue, rowIndex, colConf) {
                        return ((row.attitudeScore || 0) + (row.skillsScore || 0) + (row.qualityScore || 0)) == 15 ? '是' : '';
                    },
                    'freeFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.freeFlag) {
                            return '<span class="swb-tags swb-tags-success">' + "免费" + '</span>'
                        } else {
                            return '<span class="swb-tags swb-tags-danger">' + "收费" + '</span>'
                        }
                    },
                    'techState': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.techAuditRequired) {
                            if(row.techApplyState == 0) {
                                return '未申请';
                            }
                            if(row.techApplyState == 1) {
                                return '待审核';
                            }
                            if(row.techApplyState == 2) {
                                if(row.techAuditState == 1) {
                                    return '审核通过';
                                } else {
                                    return '审核未通过';
                                }
                            }
                        }
                    }
                });
            },
            renderTable(rows, pagination)
            {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            }
            ,
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            }
            ,
            getTableSelection()
            {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            }
            ,
            queryHandler(queryModel)
            {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getServcWorkVoucherList();
            }
            ,
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getServcWorkVoucherList();
            }
            ,
            //
            getServcWorkVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                // 工单截止时间
                if(!Utils.isNoB(filterItems.yqFinishTimeFrom)) {
                    filterItems.yqFinishTimeFrom = new Date(filterItems.yqFinishTimeFrom).format('yyyy-MM-dd HH:mm');
                }
                if(!Utils.isNoB(filterItems.yqFinishTimeTo)) {
                    filterItems.yqFinishTimeTo = new Date(filterItems.yqFinishTimeTo).format('yyyy-MM-dd HH:mm');
                }
                if(Utils.isNoB(self.masterId)) {
                    MsgBox.warning("未找到对应的主工单信息");
                    return;
                }
                filterItems.masterId = self.masterId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportParams = filterItems;
                let theLoad = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherByMasterIdList(postData, function (result) {
                    if(result.type == "info") {
                        let servcWorkVoucherList = result.data.rows;
                        if(!Utils.isNoB(servcWorkVoucherList) && servcWorkVoucherList.length > 0) {
                            for(let i = 0; i < servcWorkVoucherList.length; i++) {
                                let servcWorkVoucher = servcWorkVoucherList[i];
                                let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                                servcWorkVoucher.stateText = stateInfo.text;
                            }
                        }
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //

                        self.renderTable(result.data.rows, pagination);
                        theLoad.hide();
                    } else {
                        theLoad.hide();
                        MsgBox.warning(result.message);
                    }
                })
            }
            ,
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherDlgtList.vue